<template>
  <div class="modal-checkout-operator">
    <ModalBase v-bind="$attrs" v-on="$listeners" @change:modal="onChangeModal">
      <div slot="content">
        <div class="modal-checkout-operator__content">
          <h1>{{ lang.title }}</h1>
          <div>
            <CountDown countdown :minutes="1" :size="62" @countdown-time-out="onTimeOut" />
          </div>
          <div class="text-xs-center">
            <Button
              :text="lang.button"
              color="success"
              :handleClick="onButtonClick"
              icon
              right
              class="modal-checkout-operator__btn"
            ></Button>
          </div>
        </div>
      </div>
    </ModalBase>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ModalBase from "./ModalBase";
import Button from "./Button";
import CountDown from "./CountDown";

export default {
  inheritAttrs: false,
  components: {
    ModalBase,
    Button,
    CountDown,
  },
  data() {
    return {
      locale: null,
    };
  },
  computed: {
    ...mapState({
      locales: (state) => state.locales.locales,
      employee: (state) => state.employee.employee,
    }),
    lang() {
      return {
        title: this.$t(window.Vocabulary.toShutdown),
        button: this.$t(window.Vocabulary.continueWork),
      };
    },
  },
  methods: {
    onButtonClick() {
      this.$emit("confirm", true);
    },
    onTimeOut() {
      this.$emit("confirm", false);
    },
    onChangeModal(val) {
      if (!val) {
        this.$emit("confirm", true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-checkout-operator {
  &__content {
    text-align: center;
    h1 {
      margin-bottom: 15px;
      font-size: 32px;
    }
  }

  &__btn {
    margin-top: 50px;
    /deep/ .v-btn__content {
      font-size: 16px !important;
    }
  }
}
</style>
